
export default {
	addresses: {},
	addressIds: [],
}